import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isPortal = false;
  isLoading = true;
  private routerSub!: Subscription;


  constructor(
    private translate: TranslateService,
    private router: Router,

  ) {
    // i18n defaults
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {

    // Detect portal vs home
    this.updatePortalFlag();

    // Router events → spinner
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isLoading = true;
      }
      if (event instanceof NavigationEnd) {
        // Update portal flag on every successful navigation
        this.updatePortalFlag();
        setTimeout(() => this.isLoading = false, 500);
      }
      if (event instanceof NavigationError) {
        setTimeout(() => this.isLoading = false, 500);
      }
    });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();

  }

  /** Determine if we are inside the portal (not home) */
  private updatePortalFlag(): void {
    const path = window.location.pathname;
    this.isPortal = !(path.startsWith('/home') || path === '/');
  }

  // Uncomment when you need language switching
  // switchLanguage(lang: string) {
  //   this.translate.use(lang);
  //   document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  // }
}
